<template>
  <b-modal
    id="gerar-codigo-acesso-modal"
    no-close-on-esc
    no-close-on-backdrop
    hide-header
    hide-footer
    centered
    v-model="showModal"
    @hidden="resetForm"
  >
    <div class="d-flex flex-column my-2">
      <h2 class="mb-2">Gerar Código de Acesso</h2>

      <validation-observer ref="formObserver">
        <b-form>
          <b-row>
            <b-col lg="12" md="12" sm="12">
              <b-form-group label="Nome do colaborador" label-for="nome-colaborador">
                <b-form-input
                  id="nome-colaborador"
                  :value="colaborador.nome"
                  disabled
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" md="12" sm="12">
              <b-form-group label="CPF" label-for="cpf-colaborador">
                <b-form-input
                  id="cpf-colaborador"
                  v-mask="'###.###.###-##'"
                  :value="colaborador.cpf"
                  disabled
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col lg="12" md="12" sm="12">
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-group label="E-mail do colaborador*" label-for="email-input">
                  <b-form-input
                    id="email-input"
                    v-model="formData.email"
                    type="email"
                    placeholder="Digite o e-mail do colaborador"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <div v-if="codigoGerado" class="mt-1 p-2 bg-light rounded">
            <h6 class="mb-2">Código de Acesso:</h6>
            <div class="d-flex align-items-center mb-2">
              <b-form-input
                :value="codigoGerado"
                readonly
                class="font-weight-bold text-center"
              />
              <b-button
                variant="outline-primary"
                size="sm"
                class="ml-2"
                @click="copiarCodigo"
              >
                <feather-icon icon="CopyIcon" size="14" />
              </b-button>
            </div>
            <small class="text-muted">Válido por 72 horas a partir da geração.</small>
          </div>

          <div class="d-flex justify-content-end mt-3">
            <b-button
              v-if="!codigoGerado"
              :disabled="loading"
              variant="outline-secondary"
              class="mr-2"
              @click="cancelAction"
            >
              Cancelar
            </b-button>
            <b-button
              v-if="!codigoGerado" 
              :disabled="loading || !colaborador.id_pessoa_fisica"
              variant="custom-blue"
              @click.prevent="handleSubmit"
            >
              <span v-if="loading" class="spinner-border spinner-border-sm mr-1"></span>
              Gerar Código de Acesso
            </b-button>
            <b-button
              v-if="codigoGerado"
              variant="custom-blue"
              @click="fecharModal"
            >
              Fechar
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BCol,
  BRow,
  BFormGroup,
  BFormInput,
  BButton
} from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email } from '@validations';
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';

export default {
  name: 'GerarCodigoAcessoModal',
  components: {
    BModal,
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    ValidationProvider,
    ValidationObserver,
    FeatherIcon,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    colaborador: {
      type: Object,
      default: () => ({
        id_pessoa_fisica: null,
        nome: '',
        cpf: '',
      }),
    },
  },
  data() {
    return {
      formData: {
        email: '',
      },
      loading: false,
      codigoGerado: '',
      required,
      email,
    };
  },
  watch: {
    showModal(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    async gerarCodigoAcesso() {
      if (!this.colaborador.id_pessoa_fisica) {
       this.$toast.error('ID da pessoa física não encontrado. Por favor, tente novamente.');
        return;
      }

      const isValid = await this.$refs.formObserver.validate();

      if (!isValid) {
        this.$toast.error('Por favor, preencha o e-mail corretamente.');
        return;
      }

      this.loading = true;

      try {
        const response = await this.$http.post(
          this.$api.gerarCodigoAcessoPessoaFisica(this.colaborador.id_pessoa_fisica),
          {
            email: this.formData.email,
          }
        );

        if (response.status === 200) {
          this.codigoGerado = response.data.codigo_acesso;
          this.$toast.success('Código de acesso gerado com sucesso!');
        }
      } catch (error) {
        const response = error.response.data;
        this.$toast.error(response.errors)
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      await this.gerarCodigoAcesso();
    },
    copiarCodigo() {
      navigator.clipboard.writeText(this.codigoGerado).then(() => {
        this.$toast.success('Código de acesso copiado!')
      }).catch(() => {
        this.$toast.error('Erro ao copiar códigode  acesso')
      });
    },
    cancelAction() {
      this.$emit('canceled');
    },
    fecharModal() {
      this.$emit('closed', !!this.codigoGerado);
    },
    resetForm() {
      this.formData.email = '';
      this.codigoGerado = '';
      this.loading = false;
      if (this.$refs.formObserver) {
        this.$refs.formObserver.reset();
      }
    },
  },
};
</script>

<style scoped>
.bg-light {
  background-color: #f8f9fa !important;
}
</style>
